import React, { useState } from 'react';
import { Icon, Modal, Button } from 'components/ui';
import { routes, RSVP_STATUS } from 'constants/config';
import request from 'utils/request_ajax';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { getStatusText } from '../../helpers';
import RSVPPopover from './RSVPPopover';

const RSVPStatus = ({
  attendee,
  event,
  showAttendanceDropdown,
  updateAttendance,
  isMultiSession,
  currentSessionId,
  rsvpType,
  sessions,
  rsvpHideAlert,
}) => {
  const session = attendee.sessions[0];
  const { createdFrom, rsvpStatus } = session;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [confirmRsvpModal, setConfirmRsvpModal] = useState(false);
  const [checkBoxClicked, setCheckBoxClicked] = useState(false);
  const currentSession = currentSessionId
    ? sessions.find(
        eventSession => Number(eventSession.id) === Number(currentSessionId),
      )
    : sessions[0];
  const attendanceTaken = currentSession.attendance_taken;

  const removeAttendance = () => {
    const url = routes.IN_PERSON_TRAINING.SESSION_ATTENDANCE(
      session.id,
      session.attendanceId,
    );
    request.delete(url).then(({ success }) => {
      if (success) updateAttendance();
    });
  };

  const changeAttendanceStatus = newStatus => {
    const url = routes.IN_PERSON_TRAINING.RSVP_ALL_GUESTS(event.id);
    request
      .putJSON(url, {
        userId: attendee.id,
        rsvpStatus: newStatus,
        rsvpHideAlert: rsvpHideAlert || checkBoxClicked,
      })
      .then(({ data }) => {
        if (data?.sessions.length) {
          const updateSession = currentSessionId
            ? data.sessions.find(x => x.id === currentSessionId)
            : data.sessions[0];
          updateAttendance(updateSession);
          setPopoverOpen(false);
        }
      });
  };

  const changeAttendanceStatusSingle = newStatus => {
    const url = routes.IN_PERSON_TRAINING.RSVP_SINGLE_GUESTS(
      event.id,
      currentSessionId,
    );

    request
      .putJSON(url, {
        userId: attendee.id,
        rsvpStatus: newStatus,
        rsvpHideAlert: rsvpHideAlert || checkBoxClicked,
      })
      .then(({ data }) => {
        if (data?.sessions.length) {
          updateAttendance(data.sessions.find(x => x.id === currentSessionId));
          setPopoverOpen(false);
        }
      });
  };

  if (createdFrom === 'created_manually' && event.last_session) {
    return null;
  }

  const updateRsvpModal = () => {
    const CHANGE_STATUS =
      rsvpStatus === RSVP_STATUS.WILL_NOT_ATTEND
        ? RSVP_STATUS.WILL_ATTEND
        : RSVP_STATUS.WILL_NOT_ATTEND;
    if (rsvpType === 'single') {
      changeAttendanceStatusSingle(CHANGE_STATUS);
    } else {
      changeAttendanceStatus(CHANGE_STATUS);
    }
    setConfirmRsvpModal(!confirmRsvpModal);
  };

  return (
    <>
      <div>{getStatusText(rsvpStatus, true)}</div>
      {showAttendanceDropdown && !attendanceTaken && !isMultiSession && (
        <div className="pos-r">
          <button
            type="button"
            onClick={() => setPopoverOpen(!popoverOpen)}
            className="u-resetBtn AttendanceRowActions"
          >
            <Icon name="chevron-down" />
          </button>
          {popoverOpen && (
            <RSVPPopover
              removeAttendance={removeAttendance}
              changeAttendanceStatus={changeAttendanceStatus}
              status={rsvpStatus}
              hide={() => setPopoverOpen(!popoverOpen)}
              isMultiSession={isMultiSession}
              rsvpHideAlert={rsvpHideAlert}
              setConfirmRsvpModal={setConfirmRsvpModal}
              rsvpType={rsvpType}
            />
          )}
        </div>
      )}
      {showAttendanceDropdown &&
        !attendanceTaken &&
        isMultiSession &&
        currentSessionId && (
          <div className="pos-r">
            <button
              type="button"
              onClick={() => setPopoverOpen(!popoverOpen)}
              className="u-resetBtn AttendanceRowActions"
            >
              <Icon name="chevron-down" />
            </button>
            {popoverOpen && (
              <RSVPPopover
                removeAttendance={removeAttendance}
                changeAttendanceStatus={
                  rsvpType === 'single'
                    ? changeAttendanceStatusSingle
                    : changeAttendanceStatus
                }
                status={rsvpStatus}
                isMultiSession={isMultiSession}
                hide={() => setPopoverOpen(!popoverOpen)}
                rsvpHideAlert={rsvpHideAlert}
                setConfirmRsvpModal={setConfirmRsvpModal}
                rsvpType={rsvpType}
              />
            )}
          </div>
        )}
      <Modal
        shown={confirmRsvpModal}
        onDismiss={() => setConfirmRsvpModal(!confirmRsvpModal)}
        canClickAway
        className="w-35p Modal-shell"
        enableFloatingDismiss
      >
        <Modal.Content>
          <>
            <div className="d-f fd-c">
              <Text variant={TEXT_VARIANTS.TITLE} className="mb-4 tt-c">
                {t('in_person_training.event_overview.rsvp_confirmation.title')}
              </Text>
              <Text variant={TEXT_VARIANTS.BODY} className="mt-12 mb-4">
                {rsvpType === 'single'
                  ? t(
                      'in_person_training.event_overview.rsvp_confirmation.description.single',
                    )
                  : t(
                      'in_person_training.event_overview.rsvp_confirmation.description.all',
                    )}
              </Text>
            </div>
          </>
          <>
            <div className="d-f jc-s mt-24">
              <input
                className="mt-0-imp"
                type="checkbox"
                id="RsvpCheckbox"
                name="RsvpCheckbox"
                onChange={e => setCheckBoxClicked(e.target.checked)}
              />
              <Text
                variant={TEXT_VARIANTS.BODY}
                className="d-f ai-c ml-8"
                htmlFor="RsvpCheckbox"
              >
                {t(
                  'in_person_training.event_overview.rsvp_confirmation.message',
                )}
              </Text>
              <Button
                className="mr-8 tt-c ml-a"
                type="button"
                onClick={() => setConfirmRsvpModal(!confirmRsvpModal)}
              >
                {t('common.cancel')}
              </Button>

              <Button
                className="tt-c backgroundColor-blue"
                type="button"
                onClick={updateRsvpModal}
                customColor
              >
                {t(
                  'in_person_training.event_overview.rsvp_confirmation.update',
                )}
              </Button>
            </div>
          </>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default RSVPStatus;
